import styled, { css } from 'styled-components';
const centerContentStyle = css `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const multipleModeStyle = css `
  ${({ multipleMode }) => multipleMode && 'background-color: rgba(102, 174, 255, 0.20);'}
`;
const sideLimitStyle = css `
  ${({ isSideLimit }) => isSideLimit &&
    `
      max-width: 31px;
      max-height: 31px;
      border-radius: ${isSideLimit === 'left' ? '50px 0px 0px 50px' : '0px 50px 50px 0px'};
    `};
`;
export const DateSlotStyled = styled.div `
  flex-basis: 14.2857%;
  flex-direction: column;
  flex-shrink: 0;
  ${sideLimitStyle}
  width: 36.859px;
  height: 30.395px;
  ${multipleModeStyle};
  @media (max-width: 350px) {
    width: 29px;
    height: 29px;
    max-width: 29px;
    max-height: 29px;
  }
  ${centerContentStyle};
`;
export const SelectedDateSlotStyled = styled.div `
  width: 29px;
  height: 29px;
  flex-shrink: 0;
  border-radius: 50px;
  background: ${({ theme, selected }) => (selected ? theme.colors.gray100 : theme.colors.blue400)};
  ${({ selected }) => selected &&
    `
    border: 1px solid #d6e3f3;
    box-shadow: 4px 4px 14px 0px #d9d9d9 inset, -4px -4px 9px 0px rgba(255, 255, 255, 0.88) inset;
  `}
  ${centerContentStyle}
`;
//# sourceMappingURL=styled.js.map